export default __webpack_public_path__ + "static/media/logoteamb.b885fb58.svg";